import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ThemeColors } from '../../web/components-v2/Theme/theme';
import { toSentenceCase } from '../../web/utils/toSentenceCase';

interface UseTagCategoryColorMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface TagCategoryColorMutationParams {
	categoryId: string;
	color: keyof ThemeColors['pill'];
	impersonationContext?: Api.IImpersonationContext;
}

export function useTagCategoryColorMutation({ onSuccess, onError }: UseTagCategoryColorMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ categoryId, color, impersonationContext }: TagCategoryColorMutationParams) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tagcategory/${categoryId}/color`,
					queryParams: {
						value: toSentenceCase(color),
					},
				}),
				'PUT'
			);
		},
		onSuccess,
		onError,
	});
}
